/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.29.35
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PrizeRevealMethod } from './PrizeRevealMethod';
import {
    PrizeRevealMethodFromJSON,
    PrizeRevealMethodFromJSONTyped,
    PrizeRevealMethodToJSON,
} from './PrizeRevealMethod';
import type { S2WTheme } from './S2WTheme';
import {
    S2WThemeFromJSON,
    S2WThemeFromJSONTyped,
    S2WThemeToJSON,
} from './S2WTheme';

/**
 * A back-office edit of a Spin-to-Win game. Replaces every editable setting, like the data import does. An omitted or
 * null dailySpinLimit means no limit. The theme must be one the client can render, and the prize reveal method is
 * always stated rather than left to the double-wheel default.
 * @export
 * @interface S2WGameUpdateRequest
 */
export interface S2WGameUpdateRequest {
    /**
     * 
     * @type {number}
     * @memberof S2WGameUpdateRequest
     */
    wheelTextLimit: number;
    /**
     * 
     * @type {number}
     * @memberof S2WGameUpdateRequest
     */
    promoTextLimit: number;
    /**
     * Hard limit on the number of times a single player can play this spin to win game per day. This can be
     * null/undefined if there is no limit.
     * @type {number}
     * @memberof S2WGameUpdateRequest
     */
    dailySpinLimit?: number | null;
    /**
     * The cost in points to spin the wheel
     * @type {number}
     * @memberof S2WGameUpdateRequest
     */
    pointCost: number;
    /**
     * 
     * @type {string}
     * @memberof S2WGameUpdateRequest
     */
    name: string;
    /**
     * 
     * @type {PrizeRevealMethod}
     * @memberof S2WGameUpdateRequest
     */
    prizeRevealMethod: PrizeRevealMethod;
    /**
     * 
     * @type {S2WTheme}
     * @memberof S2WGameUpdateRequest
     */
    theme: S2WTheme;
}



/**
 * Check if a given object implements the S2WGameUpdateRequest interface.
 */
export function instanceOfS2WGameUpdateRequest(value: object): value is S2WGameUpdateRequest {
    if (!('wheelTextLimit' in value) || value['wheelTextLimit'] === undefined) return false;
    if (!('promoTextLimit' in value) || value['promoTextLimit'] === undefined) return false;
    if (!('pointCost' in value) || value['pointCost'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('prizeRevealMethod' in value) || value['prizeRevealMethod'] === undefined) return false;
    if (!('theme' in value) || value['theme'] === undefined) return false;
    return true;
}

export function S2WGameUpdateRequestFromJSON(json: any): S2WGameUpdateRequest {
    return S2WGameUpdateRequestFromJSONTyped(json, false);
}

export function S2WGameUpdateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): S2WGameUpdateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'wheelTextLimit': json['wheelTextLimit'],
        'promoTextLimit': json['promoTextLimit'],
        'dailySpinLimit': json['dailySpinLimit'] == null ? undefined : json['dailySpinLimit'],
        'pointCost': json['pointCost'],
        'name': json['name'],
        'prizeRevealMethod': PrizeRevealMethodFromJSON(json['prizeRevealMethod']),
        'theme': S2WThemeFromJSON(json['theme']),
    };
}

export function S2WGameUpdateRequestToJSON(value?: S2WGameUpdateRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'wheelTextLimit': value['wheelTextLimit'],
        'promoTextLimit': value['promoTextLimit'],
        'dailySpinLimit': value['dailySpinLimit'],
        'pointCost': value['pointCost'],
        'name': value['name'],
        'prizeRevealMethod': PrizeRevealMethodToJSON(value['prizeRevealMethod']),
        'theme': S2WThemeToJSON(value['theme']),
    };
}

